import { useQuery } from "@tanstack/react-query";
import { callApi } from "../callEndpoint";
import {
  appointmentSlotEndpoints,
  type AvailableTimeSlotsRequest,
  type AvailableTimeSlotsListResponse,
  type AvailableTimeSlotsDto,
} from "../contracts/appointment-slots.contract";

export const useAvailableTimeSlots = (params: AvailableTimeSlotsRequest) =>
  useQuery({
    queryKey: ["available-time-slots", params],
    queryFn: async (): Promise<AvailableTimeSlotsDto[]> => {
      const data = await callApi<AvailableTimeSlotsListResponse>(
        appointmentSlotEndpoints.available,
        { params },
      );
      return data.availableTimeSlots;
    },
    enabled: !!params.slug,
  });
